import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import './Footer.css';

const T = {
  about: { ko: '회사소개', en: 'About' },
  products: { ko: '제품소개', en: 'Products' },
  partner: { ko: '(주)더부러', en: 'Deobureo Inc.' },
  notice: { ko: '공지사항', en: 'Notice' },
  qna: { ko: 'Q&A', en: 'Q&A' },
  contact: { ko: '문의하기', en: 'Contact' },
  privacy: { ko: '개인정보 처리방침', en: 'Privacy Policy' },
  copyright: { ko: '© 2025 (주)메디로지스. All Rights Reserved.', en: '© 2025 MEDILOGIS Inc. All Rights Reserved.' },
};

function Footer() {
  const navigate = useNavigate();
  const { lang } = useLang();

  const goTo = (e, path) => {
    e.preventDefault();
    if (path.startsWith('/#')) {
      sessionStorage.setItem('scrollTo', path.replace('/#', ''));
      navigate('/');
    } else {
      navigate(path);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-columns">
          <div className="footer-col">
            <h4>Company</h4>
            <a href="/#about" onClick={(e) => goTo(e, '/#about')}>{T.about[lang]}</a>
          </div>
          <div className="footer-col">
            <h4>Products</h4>
            <a href="/#products" onClick={(e) => goTo(e, '/#products')}>{T.products[lang]}</a>
          </div>
          <div className="footer-col">
            <h4>Cooperation</h4>
            <a href="https://www.1588-8076.com/" target="_blank" rel="noopener noreferrer">{T.partner[lang]}</a>
          </div>
          <div className="footer-col">
            <h4>Notification</h4>
            <a href="/notice" onClick={(e) => goTo(e, '/notice')}>{T.notice[lang]}</a>
          </div>
          <div className="footer-col">
            <h4>Communication</h4>
            <a href="/#qna" onClick={(e) => goTo(e, '/#qna')}>{T.qna[lang]}</a>
            <a href="/#contact" onClick={(e) => goTo(e, '/#contact')}>{T.contact[lang]}</a>
          </div>
        </div>
        <div className="footer-divider"></div>
        <div className="footer-bottom">
          <a href="/privacy" className="footer-privacy" onClick={(e) => goTo(e, '/privacy')}>{T.privacy[lang]}</a>
          <p>{T.copyright[lang]}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
